export const RUTA = {
    CASOS_CLINICOS: {
        MEDICO: 'medico',
        ADMINISTRADOR: 'administrador',
        ENFERMERA: 'enfermera',
        SUPERVISOR: 'supervisor'
    }
}